import React from 'react';
import toolbarStyles from '../Toolbar/Toolbar.module.css';

const ToolbarHDivider = () => <div className={toolbarStyles.toolHDivider} />;

export default ToolbarHDivider;
